import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import * as moment from 'moment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {Router} from '@angular/router';
import {OrderLogService} from '../../../Services/order-log.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-order-log',
  templateUrl: './order-log.component.html',
  styleUrls: ['./order-log.component.scss']
})
export class OrderLogComponent implements OnInit {
  public grid: Grid;
  public baseUrl = environment.apiUrl;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(private auth: AuthenticationService, private router: Router, private orderLogService: OrderLogService) {
  }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat() + ' HH:mm';
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.product.order_log.Last_updated',
          prop: 'created',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.product.order_log.total_records',
          prop: 'totalRecords',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
        },
        <ActionColumn>{
          name: 'doctrine.product.order_log.action',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          width: 100,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-file-text-o fa-lg',
              tooltip: 'global.view_log',
              onclick: row => {
                const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
                el.setAttribute('href', this.baseUrl + '/download?path=' + row.logFile.path
                  + '&filename=' + row.logFile.filename);
                el.setAttribute('download', row.logFile.filename);
                el.click();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.orderLogService,
      rememberURL: this.router.url,
      method: 'getOrderLog',
      defaultSort: 'created',
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
        }
      ],
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
    };
  }

}
